<template>
  <div style="margin-top: 24px">
    <el-form ref="form" :model="form" :rules="rules" label-width="200px" label-position="left">
      <div class="mb-48">
        <div class="section-title mb-16">{{ $t('merchantAccount.beneficiary_details') }}</div>
        <el-form-item
          class="mt-12"

          :label="$t('merchantAccount.beneficiary')+ ':'"
          prop="beneficiary_id"
          :rules="[
            { required: true, message: 'Beneficiary cannot be empty', trigger: ['blur','change']}
          ]"
        >
          <el-select v-model="form.beneficiary_id" class="from-input" :disabled="id_disabled" :placeholder="$t('merchantAccount.beneficiary')" clearable @change="onChangeBeneficiaryList">
            <el-option
              v-for="(item,index) in beneficiaryList"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="$store.getters.curCountry.country_code === 'TH'"
          :label="$t('merchantAccount.beneficiary_account_type') + ':'"
        >
          {{ beneficiaryAccountTypeFormat(merchantInfo.beneficiary_account_type) }}
        </el-form-item>
        <el-form-item
          v-if="$store.getters.curCountry.country_code === 'TH' && merchantInfo.beneficiary_account_type === 'PROMPTPAY'"
          :label="$t('merchantAccount.beneficiary_type') + ':'"
        >
          {{ beneficiaryTypeFormat(merchantInfo.beneficiary_type) }}
        </el-form-item>
        <el-form-item
          v-if="$store.getters.curCountry.country_code !== 'TH' || merchantInfo.beneficiary_account_type === 'BANK'"
          :label="$t('merchantAccount.receiving_channel') + ':'"
        >
          {{ merchantInfo.disbursement_channel }}
        </el-form-item>
        <el-form-item
          :label="$t('merchantAccount.beneficiary_name') + ':'"
        >
          {{ merchantInfo.disbursement_name }}

        </el-form-item>
        <el-form-item
          :label="$t('merchantAccount.beneficiary_account_no') + ':'"
        >
          {{ merchantInfo.disbursement_number }}
        </el-form-item>
        <el-form-item
          :label="$t('merchantAccount.amount_limit') + ':'"
        >
          <div v-if="merchantInfo.disbursement_payout_limit_amount === 1">
            {{ merchantInfo.contract_amount | toDivideWithDot }}
          </div>
          <div v-else>
            /
          </div>
        </el-form-item>
      </div>

      <div class="mb-48">
        <div class="section-title mb-16">{{ $t('merchantAccount.payment_details') }}</div>
        <!-- 商户订单号 -->
        <el-form-item
          :label="$t('merchantAccount.merchant_order_id')"
          prop="merchant_order_id"
        >
          <el-input
            v-model.trim="form.merchant_order_id"
            maxlength="32"
            show-word-limit
            placeholder="Enter merchant order ID"
            type="text"
            class="from-input"
            autocomplete="off"
            clearable
          />
        </el-form-item>
        <el-form-item
          :label="$t('components.amount')"
          prop="amount"
          :rules="[
            { required: true, message: 'Amount cannot be empty', trigger: ['blur','change']},
            { validator: checkAmount, trigger: ['blur','change'] }
          ]"
        >
          <el-input v-model="form.amount" type="text" placeholder="Enter amount" class="from-input" autocomplete="off" clearable />
        </el-form-item>
        <el-form-item
          required
          :label="$t('merchantAccount.payment_remark') + ':'"
          prop="remark"
        >
          <el-input v-model="form.remark" placeholder="Enter your message here" style="width: 450px" class="from-input" type="textarea" maxlength="256" clearable overflow: auto show-word-limit />
        </el-form-item>
        <el-form-item
          v-if="$store.getters.isOpenMfa"
          :label="$t('system.mfa_verify_code') + ':'"
          style="width: 600px"
          prop="mfa_code"
          required
        >
          <el-input v-model="form.mfa_code" placeholder="Enter your MFA verification code" class="from-input" maxlength="6" autocomplete="off" clearable show-word-limit />
        </el-form-item>
      </div>
    </el-form>

    <div class="cp-btn">
      <el-button type="info" plain class="btn-footer" @click="onClickCancelBtn">{{ $t('components.cancel') }}</el-button>
      <el-button class="btn-footer" type="info" :disabled="submiting" @click="onClickSubmitBtn">{{ $t('components.confirm') }}</el-button>
    </div>
  </div>
</template>

<script>
import { createLargeDisbursement, fetchLargeValueBeneficiaryAllList } from '@/api/online-transaction/online-transaction.js'
export default {
  name: 'Payment_Details_Modal',
  components: {
  },
  props: {
    balance: {
      type: Number,
      default: 0
    }
  },
  data() {
    const validateVerifyCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please input MFA Verification Code'))
      }
      if (value.includes(' ')) {
        return callback(new Error('Please do not enter spaces'))
      }
      if (value.length !== 6 || !/^\d+$/.test(value)) {
        return callback(new Error('Please enter 6 digit valid MFA Verification code'))
      }
      return callback()
    }
    this.checkAmount = (rule, value, callback) => {
      value = Number(value)
      // 越南大额付款金额上下限: 200,000,001 ~ 300,000,000 VND
      if (this.$store.getters.isVnMerchant) {
        if (value < 200000001) {
          return callback(new Error(this.$t('send_pagements.large_payment_min_amount')))
        }
        if (value > 300000000) {
          return callback(new Error(this.$t('send_pagements.large_payment_max_amount')))
        }
      } else if (!this.$store.getters.isCurIDCountry && value > 10000000) {
        return callback(new Error('Currently up to 10 million'))
      }
      this.$commonFn.validateFormAmount({rule, value, callback })
      if (value > this.$commonFn.mathDivide(this.balance, 100)) {
        return callback(new Error('Insufficient balance!'))
      }
      if (!this.$store.getters.isVnMerchant && this.form.amount > this.maxAmount) {
        return callback(new Error('The payment amount cannot exceed the amount limit.'))
      }
      callback()
    }
    return {
      id: null,
      listLoading: false,
      merchantInfo: {},
      form: {
        amount: undefined,
        beneficiary_id: null,
        mfa_code: ''
      },
      beneficiaryList: [],
      submiting: false,
      id_disabled: false,
      paymentType: 1,
      rules: {
        mfa_code: [
          { validator: validateVerifyCode, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  computed: {
    beneficiaryAccountTypeFormat() {
      const obj = {
        'BANK': this.$t('map.beneficiary_account_type_0'),
        'PROMPTPAY': this.$t('map.beneficiary_account_type_1')
      }
      return function(value) {
        if (value) {
          return obj[value]
        }
        return value
      }
    },
    beneficiaryTypeFormat() {
      const obj = {
        'NATIONAL_ID': this.$t('map.beneficiary_type_0'),
        'MOBILE_NUMBER': this.$t('map.beneficiary_type_1')
      }
      return function(value) {
        if (value) {
          return obj[value]
        }
        return value
      }
    },
    maxAmount() {
      if (this.merchantInfo.disbursement_payout_limit_amount === 1) {
        return this.$commonFn.mathDivide(this.merchantInfo.contract_amount, 100)
      } else {
        return 5000000
      }
    }
  },
  mounted() {
    this.getBeneficiaryList()
  },
  methods: {
    amountTips() {
      if (!this.$store.getters.isVnMerchant && this.form.amount > this.maxAmount) {
        this.$message.warning('The payment amount cannot exceed the amount limit.')
        return
      }
      return true
    },
    initEnterSingleLargePayoutContent(row) {
      this.initContent()
      this.getBeneficiaryList(row)
    },
    getBeneficiaryList(row) {
      fetchLargeValueBeneficiaryAllList().then(res => {
        if (res.code === 10000) {
          let list = res.data || []
          list = list.map(item => {
            return {
              ...item,
              label: `${item.disbursement_short_name} - ${item.disbursement_number}${item.disbursement_channel ? ` - ${item.disbursement_channel}` : ''}`,
              value: item.id
            }
          })
          this.beneficiaryList = list
          if (row?.id) {
            this.id_disabled = true
            this.form.beneficiary_id = row.id
            this.onChangeBeneficiaryList(row.id)
          }
        }
      })
    },
    onChangeBeneficiaryList(value) {
      if (value) {
        const item = this.beneficiaryList.find(item => item.id === value)
        this.merchantInfo = item || {}
        this.form = {
          ...this.form,
          account_name: item.disbursement_name,
          amount_limit: item.contract_amount,
          disbursement_order: item.disbursement_order,
          account_no: item.disbursement_number,
          code: item.disbursement_channel,
          merchant_id: item.merchant_id
        }
        if (this.$store.getters.curCountry.country_code === 'TH') {
          this.form.beneficiary_account_type = item.beneficiary_account_type
          if (this.form.beneficiary_account_type === 'BANK') {
            this.form.code = item.disbursement_channel
          }
          if (this.form.beneficiary_account_type === 'PROMPTPAY') {
            this.form.beneficiary_type = item.beneficiary_type
          }
        }
      } else {
        this.merchantInfo = {}
        this.form = {
          ...this.form,
          account_name: '',
          amount_limit: '',
          disbursement_order: '',
          account_no: '',
          code: '',
          merchant_id: ''
        }
      }
    },
    onClickSubmitBtn() {
      if (!this.amountTips()) {
        return
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t('tips.whether_to_submit'), this.$t('components.tips'), {
            confirmButtonText: this.$t('components.submit'),
            cancelButtonText: this.$t('components.cancel'),
            type: 'warning'
          }).then(() => {
            this.submiting = true
            // eslint-disable-next-line prefer-const
            let { amount, ...otherForm } = this.form
            amount = this.$commonFn.mathMultiply(amount, 100)
            const params = { amount, ...otherForm }
            if (params.disbursement_number) {
              params.disbursement_number = params.disbursement_number.trim()
            }
            if (params.disbursement_name) {
              params.disbursement_name = params.disbursement_name.trim()
            }

            createLargeDisbursement(params).then(res => {
              if (res.code === 10000) {
                this.$message.success('Submit SuccessFully')
                this.$emit('closeModal')
                this.$emit('updateList')
              }
            }).finally(() => {
              setTimeout(() => {
                this.submiting = false
              }, 500)
            })
          })
        }
      })
    },
    onClickCancelBtn() {
      this.$emit('closeModal')
      this.$emit('showChooseModal')
    },
    initContent() {
      this.form = {
        amount: undefined,
        beneficiary_id: null
      }
      this.merchantInfo = {}
      this.id_disabled = false
      this.$nextTick(function() {
        this.$refs['form'].clearValidate()
      })
    },
    handleChangePaymentType(value) {
      this.$emit('handleChangePaymentType', value)
    }
  }
}
</script>

<style scoped lang="scss">
.btn-container{
  margin-top: 32px;
  display: flex;
  .btn-download,.btn-retry{
    flex: 1;
  }
  .btn-retry{
    margin-left: 24px;
  }
}
.total{
  display: inline-flex;
  justify-content: space-between;
  margin-top: 18px;
  min-width: 300px;

  .line{
    display: inline-block;
    content:'';
    height: 52px;
    width: 1px;
    background: #D3D7DF;
  }
  &-title{
    font-size: 14px;
    line-height: 17px;
    color: #606266;
  }
  &-num{
    margin-top: 12px;
    font-size: 22px;
    font-family: Source Han Sans SC;
    font-weight: 600;  font-family: 'Poppins-SemiBold';
    line-height: 1.2;
    color: #3855F1;
  }
}
.item{
  display: flex;
  margin-top: 16px;
  .item-left{
    display: inline-block;
    width: 250px;
  }
}

.content-blue{
  font-weight: 500;  font-family: 'Poppins-Medium';
  font-size: 14px;
  line-height: 17px;
  background: linear-gradient(180deg, #488CE8 0%, #0058CF 100%);
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;;
}
.content-gray{
  flex: 1;
  text-align: right;
  font-weight: 500;  font-family: 'Poppins-Medium';
  font-size: 14px;
  line-height: 15px;
  color: #4B5567;
}

.from-input {
  width: 450px;
}

.mb-12{
  margin-bottom: 12px;
}
.mt-12{
  margin-top: 14px
}
.cp-btn {
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
}
.btn-footer{
  width: 170px;
}
.mt-8 {
  margin-top: 8px;
}
</style>
